import $ from 'jquery'
import debounce from 'lodash.debounce'

function init () {
  let $inputItem = $('.js-inputWrapper')

  $inputItem.length && $inputItem.each(function () {
    let $this = $(this),
      $input = $this.find('.formRow--input'),
      placeholderTxt = $input.attr('placeholder'),
      $placeholder

    $input.after('<span class="placeholder"><span class="placeholder-underline"></span><span class="placeholder-text">' + placeholderTxt + '</span></span>'),
      $input.attr('placeholder', ''),
      $placeholder = $this.find('.placeholder'),

      $input.val().length ? $this.addClass('active') : $this.removeClass('active'),

      $input.on('focusout', function () {
        $input.val().length ? ($this.addClass('active'), $this.removeClass('focus')) : ($this.removeClass('active'), $this.removeClass('focus'))
      }).on('focus', function () {
        $this.removeClass('active')
        $this.addClass('focus')
      })
    // eventlistener for "change" event
    $input.on('change', function () {
      $this.addClass('active')
    })

    $input.on('reset', function () {
      $this.removeClass('active')
      $this.find('.js-input').val('')
    })
  })

  let $textAreaItem = $('.js-textAreaWrapper')
  $textAreaItem.length && $textAreaItem.each(function () {
    let $this = $(this),
      $input = $this.find('.formRow--textarea'),
      placeholderTxt = $input.attr('placeholder'),
      $placeholder

    $input.after('<span class="placeholder"><span class="placeholder-underline"></span><span class="placeholder-text">' + placeholderTxt + '</span></span>'),
      $input.attr('placeholder', ''),
      $placeholder = $this.find('.placeholder'),

      $input.val().length ? $this.addClass('active') : $this.removeClass('active'),

      $input.on('focusout', function () {
        $input.val().length ? ($this.addClass('active'), $this.removeClass('focus')) : ($this.removeClass('active'), $this.removeClass('focus'))
      }).on('focus', function () {
        $this.removeClass('active')
        $this.addClass('focus')
      })
  })

  let $dropDownItem = $('.js-dropdownWrapper')
  $dropDownItem.length && $dropDownItem.each(function () {
    let $this = $(this),
      $field = $this.find('.formRow--dropdown-field'),
      placeholderTxt = $field.data('dropdown-field'),
      $placeholder,
      $list = $this.find('.formRow--dropdown-list'),
      $overlay = $this.find('.formRow--dropdown-overlay'),
      $select = $this.find('.formRow--dropdown-select')

    $field.after('<span class="placeholder"><span class="placeholder-underline"></span><span class="placeholder-text">' + placeholderTxt + '</span></span>'),
      $field.attr('placeholder', ''),
      $placeholder = $this.find('.placeholder')

    $field.on('click', function () {
      if (!$this.hasClass('disabled')) {
        if ($list.is(':visible')) {
          $list.hide()
          $field.removeClass('focus')
          $placeholder.removeClass('focus')
          $overlay.hide()
        } else {
          $list.show()
          $overlay.show()
          $field.addClass('focus')
          $placeholder.addClass('focus')
        }
      }
    })

    $($overlay).on('click', function (ev) {
      if ($.contains($field.get(0), ev.target) || $field.get(0) === ev.target) {
      } else {
        $list.hide()
        $overlay.hide()
        $field.removeClass('focus')
        $placeholder.removeClass('focus')
      }
    })

    // Listen to external changes of the native select and sync its selected value with the html display field (RW)
    $select.on('change', selectSync)
    $select.on('update', selectSync)

    function selectSync () {
      $field.html($(this).find('option:selected').text())
      $this.addClass('active')
      $placeholder.removeClass('focus')
    }

    $select.on('reset', function () {
      $select.val('')
      $this.removeClass('active')
      $field.html('&nbsp;')
    })

    $list.find('.formRow--dropdown-list-item').each(function () {
      $(this).on('click', function () {
        let text = $(this).find('.formRow--dropdown-list-item-text').html(),
          value = $(this).data('dropdown-value')

        $this.addClass('active')
        $field.html(text)
        $select.val(value).prop('selected', true)
        $overlay.hide()
        $field.removeClass('focus')
        $placeholder.removeClass('focus')
        $list.hide()
        $select.trigger('change', $select)
      })
    })
  })

  if ($('input.currency-format')) {
    const locale = window.backend_properties.locale.replace('_', '-')
    $('input.currency-format').on('keyup', debounce(function (event) {
      // When user select text in the document, also abort.
      let selection = window.getSelection().toString()
      if (selection !== '') {
        return
      }
      // When the arrow keys are pressed, abort.
      if ($.inArray(event.keyCode, [38, 40, 37, 39]) !== -1) {
        return
      }

      let realInput = $(this).val(),
        isNegative = realInput.indexOf('-') > -1 ? true : false,
        input = realInput.replace(/[\D\s\._]+/g, '')

      input = input ? parseInt(input, 10) : 0

      $(this).val(function () {
        if (isNegative) {
          return (input === 0) ? '-' : '-' + input.toLocaleString(locale)
        } else {
          return (input === 0) ? '' : input.toLocaleString(locale)
        }
      })
    }, 50))
  }
}

export default {
  init
}
